var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group row"},[_c('button',{staticClass:"btn btn-primary ml-3",on:{"click":_vm.procesar}},[_vm._v("Invalidar Tokens")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }